import * as $ from "jquery";

export default class FixedHeader {
	element: HTMLElement;
	hasFiller: boolean = false;

	protected filler: HTMLElement;

	constructor(el: Element) {
		this.element = <HTMLElement>el;

		if(this.element.getAttribute("data-fixed-header") === "filler") {
			this.createFiller();
		}
	}

	createFiller() {
		this.hasFiller = true;
		this.filler = document.createElement("div");
		this.filler.setAttribute("role", "presentation");
		this.element.parentElement.insertBefore(this.filler, this.element);

		this.resize();
	}

	static searchAndLoad() {
		const headers: FixedHeader[] = [];

		$("body > header[data-fixed-header]").each((i, el) => {
			const header = new this(el);
			headers.push(header)
		});

		return headers;
	}

	getHeight() {
		return this.element.offsetHeight;
	}

	resize() {
		setTimeout(() => {
			this.filler.style.height = `${ this.getHeight() }px`;
		}, 10);
	}

	watch() {
		window.addEventListener("resize", () => {
			if(this.hasFiller) {
				this.resize();
			}
		});

		requestAnimationFrame(() => {
			if(this.hasFiller) {
				this.resize();
			}
		});
	}
}